<ng-container *ngrxLet="{ provider: patientCareTeamMember$, isLoading: isLoading$ } as vm">
  @if (vm.isLoading) {
    <app-progress-spinner></app-progress-spinner>
  } @else {
    @if (vm.provider === null) {
      <div id="noProvider" data-testid="messages-topic-no-provider" class="empty">
        <p>Provider not found</p>
      </div>
    } @else {
      <div class="page" data-testid="messages-topic-page" [ngClass]="{ mobile: isMobileBrowser() }">
        <app-page-header
          [hideBack]="isModal"
          title="Select a topic"
          subtitle="This helps route your message to the right team.">
        </app-page-header>

        <div class="list" data-testid="messages-topic-list" role="list">
          <div class="flex align-center justify-center m-0 fs-14">
            <p>If this is urgent, <b>call 911</b> or visit your closest emergency room.</p>
          </div>
          @for (t of topics; track t.messageTopicId) {
            <div
              [attr.data-testid]="'messages-topic-row-' + t.messageTopicId"
              class="row"
              role="listitem"
              tabindex="0"
              [style.--accent]="t.accent"
              (click)="onClick(t.messageTopicId)"
              (keydown)="onRowKeydown($event, t.messageTopicId)">
              <div class="left" aria-hidden="true">
                <div class="icon-bubble">
                  <app-icon [name]="t.iconName" size="sm" color="on-surface"></app-icon>
                </div>
              </div>

              <div class="meta">
                <div class="name">{{ t.topic }}</div>
                <div class="sub">{{ t.description }}</div>
              </div>

              <div class="right" aria-hidden="true">
                <app-icon name="chevron_right" size="sm" color="on-surface"></app-icon>
              </div>
            </div>
          }
        </div>
      </div>
    }
  }
</ng-container>
